import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import saica_logo from '../assets/images/LOGO_SAICA.png';
import gtd_logo from '../assets/images/LOGO_GTD.png';
import dosa_logo from '../assets/images/LOGO_DRAGADOS.png';
import csic_logo from '../assets/images/LOGO_CSIC.png';

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Jan 2025 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<img src={csic_logo} alt="CSIC Logo" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%"}} />}
          >
            <h3 className="vertical-timeline-element-title">Robotics Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">CSIC, Sevilla</h4>
            <p>
              Autonomous systems, Embedded systems, Firmware development
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Apr 2024 - Jan 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<img src={dosa_logo} alt="DOSA Logo" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%"}} />}
          >
            <h3 className="vertical-timeline-element-title">Instrumentation & Control Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Eman Ingeniería - Dragados Offshore, Puerto Real</h4>
            <p>
              Wiring diagrams, I&C database management, Technical documentation
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Apr 2023 - Mar 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<img src={gtd_logo} alt="GTD Logo" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%"}} />}
          >
            <h3 className="vertical-timeline-element-title">Systems Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">GTD Defense&Security, El Puerto de Santa María</h4>
            <p>
              Wiring design, High level design, Firmware development
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--"
            date="Jun 2022 - Jan 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<img src={saica_logo} alt="Saica Logo" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%"}} />}
          >
            <h3 className="vertical-timeline-element-title">Metrology Technician</h3>
            <h4 className="vertical-timeline-element-subtitle">Saica SL, El Puerto de Santa María</h4>
            <p>
              Calibration process design, Process automation, Quality assurance
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;